import React, { ReactElement } from "react";
import NextLink from "next/link";
import { RegisterRefType } from "@/components/PageHome/interfaces";

interface Props {
  className?: string;
  active?: boolean;
  href?: string;
  onHover?: (type: "enter" | "leave") => void;
  name?: string;
  slug?: string;
  registerRef?: RegisterRefType;
}

const Chip = ({ onHover, className, href, name, slug, registerRef, ...props }: Props): ReactElement => {
  return (
    <div
      ref={(el) => {
        if (registerRef) registerRef(slug, el);
      }}
      onMouseEnter={() => {
        if (onHover && typeof onHover === "function") {
          onHover("enter");
        }
      }}
      onMouseLeave={() => {
        if (onHover && typeof onHover === "function") {
          onHover("leave");
        }
      }}
    >
      <NextLink className={`${className ? className : ""}`} href={href} {...props} prefetch={false}>
        {name}
      </NextLink>
    </div>
  );
};

export default Chip;
